export default __webpack_public_path__ + "static/media/i10.73b71216.png";